import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/first'

import { ITabInfo } from 'app/buffer-graph/models/tab-info-interface';

export abstract class TabInfoBase<T> implements ITabInfo {
    protected constructor(header: string | Observable<string>, public readonly data: T) {
        if (header instanceof Observable)
            header.first().subscribe((h: string) => this.hdr = h);
        else
            this.hdr = header;
    }

    abstract id: string;

// ReSharper disable once PrivateVariableCanBeMadeReadonly
    private hdr: string;
    get header(): string {
        return this.hdr;
    }

    isActive: boolean;
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/tab-info-base.ts